var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 1.5C5.75372 1.5 1.5 5.75372 1.5 11C1.5 16.2463 5.75372 20.5 11 20.5C16.2463 20.5 20.5 16.2463 20.5 11C20.5 5.75372 16.2463 1.5 11 1.5Z",
    fill: "#2F54EB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6946 13.602L14.4553 8.38767C14.5232 8.29303 14.4553 8.16089 14.3392 8.16089H13.5017C13.3178 8.16089 13.1464 8.25017 13.0392 8.39839L10.233 12.2381L8.96066 10.527C8.85352 10.377 8.6803 10.2895 8.49816 10.2895H7.66066C7.54459 10.2895 7.47673 10.4216 7.54459 10.5162L9.77138 13.602C9.82394 13.6753 9.89323 13.7351 9.97351 13.7763C10.0538 13.8176 10.1427 13.8391 10.233 13.8391C10.3232 13.8391 10.4122 13.8176 10.4925 13.7763C10.5727 13.7351 10.642 13.6753 10.6946 13.602Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedPrimary);
export default __webpack_public_path__ + "static/media/checked-primary.679a47148c5673705f6e0aeb3adb1a66.svg";
export { ForwardRef as ReactComponent };